//cores
import {Component, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';

//models
import {SlxAdminUsersModel} from './model/slx-admin-users.model';
import {UserFilterModel} from './model/user-filter.model';

// services
import {SlxAdminUsersService} from './service/slx-admin-users.service';
import {SearchAndPaginationService} from '../shared/services/search-and-pagination.service';

// responsiveness
import {MediaObserver} from '@angular/flex-layout';

// components
import {PaginationComponent} from '../shared/pagination/pagination.component';

// constants
import {AppConstants} from '../utils/constants';
import {PreviousPageService} from "app/shared/services/previous-page.service";
import {UtilsService} from '../utils/utils.service';
import {LangChangeEvent, TranslateService} from '@ngx-translate/core';
import {HttpParams} from "@angular/common/http";

@Component({
    selector: 'app-slx-admin-manage-users',
    templateUrl: './slx-admin-manage-users.component.html',
    styleUrls: ['./slx-admin-manage-users.component.scss'],
    standalone: false
})
export class SlxAdminManageUsersComponent implements OnInit {

  @ViewChild(PaginationComponent, {static: true}) private paginationComponent: PaginationComponent;


  public selectedStatus = AppConstants.all;
  public selectedTargetGroup = AppConstants.all;
  public selectedConfirmed = AppConstants.all;
  public selectedCustomerAdmin = AppConstants.all;
  public selectedCountry = AppConstants.all;

  private listOfUsers: Array<SlxAdminUsersModel> = new Array<SlxAdminUsersModel>();
  private userFilter = new UserFilterModel();
  private searchForm: UntypedFormGroup;
  private mobileSearchOpen: boolean;
  private totalNumberOfItems: number;

  private targetGroupValueFilter: any = null;
  private activeValueFilter: any = null;
  private confirmationValueFilter: any = null;
  private adminValueFilter: any = null;
  private countryCodeValueFilter: any = null;

  private activeStates: Array<any> = new Array<any>();
  private targetGroups: Array<any> = new Array<any>();
  private confirmationStates: Array<any> = new Array<any>();
  private adminStates: Array<any> = new Array<any>();
  private countryCodes: Array<any> = new Array<any>();
  private assignedCountries: Array<any> = new Array<any>();

  public sortingObj = {
    sortCustomerNumberField: {
      self: 'sortCustomerNumberField',
      field: AppConstants.sortCustomerNumberField,
      direction: '',
      sorting: undefined
    },
    sortCompanyField: {
      self: 'sortCompanyField',
      field: AppConstants.sortCompanyField,
      direction: '',
      sorting: undefined
    },
    sortLastNameField: {
      self: 'sortLastNameField',
      field: AppConstants.sortLastNameField,
      direction: '',
      sorting: undefined
    },
    sortFirstNameField: {
      self: 'sortFirstNameField',
      field: AppConstants.sortFirstNameField,
      direction: '',
      sorting: undefined
    },
    sortCountryCodeField: {
      self: 'sortCountryCodeField',
      field: AppConstants.sortCountryCodeField,
      direction: '',
      sorting: undefined
    },
    sortStatusField: {
      self: 'sortStatusField',
      field: AppConstants.sortStatusField,
      direction: '',
      sorting: undefined
    },
    sortIsCustomerAdminField: {
      self: 'sortIsCustomerAdminField',
      field: AppConstants.sortIsCustomerManagerField,
      direction: '',
      sorting: undefined
    },
    sortCreationDateField: {
      self: 'sortCreationDateField',
      field: AppConstants.sortCreationDateField,
      direction: 'DESC',
      sorting: false
    },
    sortLastLoginField: {
      self: 'sortLastLoginField',
      field: AppConstants.sortLastLoginField,
      direction: '',
      sorting: undefined
    },
    sortConfirmedField: {
      self: 'sortConfirmedField',
      field: AppConstants.sortConfirmedField,
      direction: '',
      sorting: undefined
    },
  };

  private sortField = null;
  private sortDirection = null;

  private loading = false;

  private homePath = AppConstants.homePage;

  private customerNumber: string;

  constructor(private _adminService: SlxAdminUsersService,
              private _router: Router,
              private _formBuilder: UntypedFormBuilder,
              public _observableMedia: MediaObserver,
              private _searchAndPaginationService: SearchAndPaginationService,
              private _previousPageService: PreviousPageService,
              private _activatedRoute: ActivatedRoute,
              private _utilsService: UtilsService,
              private _translateService: TranslateService) {
    this.searchForm = _formBuilder.group({
      searchTerm: [
        {
          value: '',
          disabled: false
        },
        Validators.required
      ],
      status: [
        {
          value: '',
          disabled: false
        },
        Validators.required
      ],
      targetGroup: [
        {
          value: '',
          disabled: false
        },
        Validators.required
      ],
      confirmation: [
        {
          value: '',
          disabled: false
        },
        Validators.required
      ],
      admin: [
        {
          value: '',
          disabled: false
        },
        Validators.required
      ],
      countryCode: [
        {
          value: '',
          disabled: false
        },
        Validators.required
      ],
    });

    _translateService.onLangChange.subscribe((event: LangChangeEvent) => {
      this.activeStates = this._utilsService.initializeSelectOrMultiselect([AppConstants.all, AppConstants.active, AppConstants.notActive]);
      this.targetGroups = this._utilsService.initializeSelectOrMultiselect(AppConstants.targetGroupsArray);
      this.confirmationStates = this._utilsService.initializeSelectOrMultiselect([AppConstants.all, AppConstants.confirmed, AppConstants.unconfirmed]);
      this.adminStates = this._utilsService.initializeSelectOrMultiselect([AppConstants.all, AppConstants.yes, AppConstants.no]);
    });

    this.getAssignedCountries();
    this.activeStates = this._utilsService.initializeSelectOrMultiselect([AppConstants.all, AppConstants.active, AppConstants.notActive]);
    this.targetGroups = this._utilsService.initializeSelectOrMultiselect(AppConstants.targetGroupsArray);
    this.confirmationStates = this._utilsService.initializeSelectOrMultiselect([AppConstants.all, AppConstants.confirmed, AppConstants.unconfirmed]);
    this.adminStates = this._utilsService.initializeSelectOrMultiselect([AppConstants.all, AppConstants.yes, AppConstants.no]);
  }

  ngOnInit() {
    this.customerNumber = this._activatedRoute.snapshot.queryParams['customerNumber'];

    if (this.customerNumber) {
      this.searchForm.controls['searchTerm'].setValue(this.customerNumber);
    }
    this._searchAndPaginationService.setOffset(0);
    this.submitRequest();
  }

  public getListOfUsers() {
    return this.listOfUsers;
  }

  public getItemsPerPage() {
    return this._searchAndPaginationService.getItemsPerPage();
  }

  public getSearchForm() {
    return this.searchForm;
  }

  public getMobileSearchOpen() {
    return this.mobileSearchOpen;
  }

  public getTotalNumberOfItems() {
    return this.totalNumberOfItems;
  }

  public getActiveStates() {
    return this.activeStates;
  }

  public getTargetGroups() {
    return this.targetGroups;
  }

  public getConfirmationStates() {
    return this.confirmationStates;
  }

  public getAdminStates() {
    return this.adminStates;
  }

  getCountryCode() {
    return this.countryCodes;
  }

  public getLoading() {
    return this.loading;
  }

  public getHomePath() {
    return this.homePath;
  }

  onSelectStatus(option) {
    this.activeValueFilter = this._utilsService.getBoolVal(option.value);
    this.submitRequest();
  }

  onSelectTGroup(option) {
    this.targetGroupValueFilter = this._utilsService.getBoolVal(option.value);
    this.submitRequest();
  }

  onSelectConfirmation(option) {
    this.confirmationValueFilter = this._utilsService.getBoolVal(option.value);
    this.submitRequest();
  }

  onSelectAdmin(option) {
    this.adminValueFilter = this._utilsService.getBoolVal(option.value);
    this.submitRequest();
  }

  onSelectCountryCode(option) {
    this.countryCodeValueFilter = this._utilsService.getBoolVal(option.value);
    this.submitRequest();
  }


  public goToNewUserPage() {
    this._router.navigate([AppConstants.slxUserDetailPath], {queryParams: {type: 'create', slx: true}});
  }

  public goToEditPage(user) {
    this._router.navigate([AppConstants.slxUserDetailPath, user.id], {queryParams: {type: 'edit', slx: true}});
  }

  /**
   * @description Get all users that match the searching term
   */
  submitRequest() {
    this.loading = true;

    if (this._searchAndPaginationService.searchKeyWordNotEquals(this.searchForm.controls['searchTerm'].value)) {
      this._searchAndPaginationService.setSearchKeyWord(this.searchForm.controls['searchTerm'].value);
    }
    this.searchForm.controls.searchTerm.setValue(this._searchAndPaginationService.getSearchKeyWord());

    const searchParams: HttpParams = this._createSearchParams();
    this._adminService.searchUsers(searchParams).subscribe(
      (res) => {
        this.loading = false;
        const response: any = res;
        this.listOfUsers = response.data;
        this._searchAndPaginationService.setItemsPerPage(response.itemsPerPage);
        this.totalNumberOfItems = response.itemsTotal;
        this.paginationComponent.setCurrentPageValue(Math.ceil(response.offset / response.itemsPerPage + 1));
      }, (error) => {
        this.loading = false;
      });
  }

  getAssignedCountries() {
    this.loading = true;
    this._adminService.loadAssignedCountries().subscribe(
      (res) => {
        this.loading = false;
        const response: any = res;
        this.mapCountries(res);
        this.countryCodes = this._utilsService.initializeSelectOrMultiselect(this.assignedCountries);

        // place "all" first in array
        const indexAll = this.countryCodes.findIndex((element) => element.value === "All");
        if (indexAll !== -1 && indexAll !== 0) {
          var element = this.countryCodes[indexAll];
          this.countryCodes.splice(indexAll, 1);
          this.countryCodes.unshift(element);
        }

      }, (error) => {
        this.loading = false;
      });

  }

  mapCountries(res) {
    for (var i = 0; i < res.length; i++) {
      this.assignedCountries.push("country." + res[i]);
    }
    this.assignedCountries.sort();
    this.assignedCountries.unshift(AppConstants.all)
  }

  /**
   * @description Clears the search input field and all projects will be be fetched
   */
  clearInputField() {
    //this.searchForm.reset();
    this.searchForm.controls['searchTerm'].reset();
    this._searchAndPaginationService.setSearchKeyWord('');
    this.submitRequest();
  }

  /**
   * @description Opens search input on mobile devices
   */
  openMobileSearch() {
    if (this._observableMedia.isActive('gt-sm')) {
      return;
    }
    this.mobileSearchOpen = true;
  }

  /**
   * @description Hides search input on mobile devices and clears the input
   */
  clearInputFieldAndCloseMobileSearch() {
    this.clearInputField();
    this.mobileSearchOpen = false;
  }

  public onPageSizeChange(pageSize: number) {
    this._searchAndPaginationService.setItemsPerPage(pageSize);
    this.submitRequest();
  }

  public onPageChange(page: number) {
    this._searchAndPaginationService.setOffset(this.getItemsPerPage() * (page - 1));
    this.submitRequest();
  }

  public sortTable(el) {
    for (const key in this.sortingObj) {
      if (el.self == key) {
        this.sortingObj[key].sorting = !this.sortingObj[key].sorting;
        if (this.sortingObj[key].sorting) {
          this.sortingObj[key].direction = 'ASC';
        } else {
          this.sortingObj[key].direction = 'DESC';
        }
        this.sortField = el.field;
        this.sortDirection = el.direction;
      } else {
        this.sortingObj[key].sorting = undefined;
      }
    }
    this.submitRequest();
  }

  private _createSearchParams(): HttpParams {
    let searchParams = new HttpParams();
    if(this._searchAndPaginationService.getSearchKeyWord() != null) {
      searchParams = searchParams.set("searchTerm", this._searchAndPaginationService.getSearchKeyWord());
    }
    if(this.activeValueFilter != null) {
      searchParams = searchParams.set("active", this.activeValueFilter);
    }
    if(this.confirmationValueFilter != null) {
      searchParams = searchParams.set("confirmed", this.confirmationValueFilter);
    }
    if(this.adminValueFilter != null) {
      searchParams = searchParams.set("customerManager", this.adminValueFilter);
    }
    if(this.countryCodeValueFilter != null) {
      searchParams = searchParams.set("country", this.countryCodeValueFilter);
    }
    if(this.targetGroupValueFilter != null) {
      searchParams = searchParams.set("targetGroup", this.targetGroupValueFilter);
    }
    if(this.sortField != null) {
      searchParams = searchParams.set("field", this.sortField);
    }
    if(this.sortDirection != null) {
      searchParams = searchParams.set("order", this.sortDirection);
    }
    if(this._searchAndPaginationService.getOffset() != null) {
      searchParams = searchParams.set("offset", this._searchAndPaginationService.getOffset());
    }
    if(this._searchAndPaginationService.getItemsPerPage() != null) {
      searchParams = searchParams.set("pageSize", this._searchAndPaginationService.getItemsPerPage());
    }
    return searchParams;
  }

}
